import api from "../api";

let prevPath = null;

// Privacy-first page view ping: no cookies, the backend hashes IP+UA per day.
export const trackPageView = (path) => {
  api.post("/track/pageview", { path, referrer: document.referrer || "" }).catch(() => {});
  if (!path.startsWith("/deal/")) prevPath = path;
};

// Where a deal view came from, used by /my/traffic-sources.
export const viewSource = (explicit) => {  if (explicit) return explicit;
  const p = prevPath || "";
  if (p.startsWith("/lytemap") || p.startsWith("/spot/")) return "map";
  if (p.startsWith("/browse") || p.startsWith("/categories") || p.startsWith("/near-expiry") || p === "/") return "browse";
  if (p.startsWith("/business/") || p.startsWith("/businesses")) return "profile";
  if (p.startsWith("/favourites") || p.startsWith("/my-deals") || p.startsWith("/following")) return "browse";
  return "direct";
};

// Fire a Plausible custom/goal event for conversion tracking. Cookieless and a safe no-op if
// Plausible hasn't loaded (blocked, offline, etc.) — analytics must never break the app.
export const plausibleEvent = (event, props) => {
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible(event, props ? { props } : undefined);
    }
  } catch {
    /* ignore */
  }
};
